<template>
  <div v-if="show" class="main-panel__top-bar text-center clickable">
    <p class="main-panel__top-bar-content">
            <span class="main-panel__top-bar-icon">
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1701_7763)">
                        <path
                          d="M17.7609 3.50599H16.3779C16.5603 3.23248 16.6807 2.92546 16.715 2.60075C16.8246 1.56305 16.2478 0.632812 15.2657 0.220394C14.363 -0.158696 13.3485 -0.00372744 12.618 0.623952L10.8716 2.12337C10.5315 1.77096 10.0426 1.54948 9.5 1.54948C8.95642 1.54948 8.46673 1.77166 8.12654 2.12516L6.37795 0.623776C5.64627 -0.0039032 4.63222 -0.158274 3.7299 0.220605C2.74806 0.633058 2.17108 1.56361 2.28108 2.60128C2.31548 2.92574 2.43579 3.23262 2.61818 3.50599H1.23912C0.554748 3.50599 0 4.03158 0 4.67989V6.44076C0 6.76491 0.277393 7.02773 0.619578 7.02773H18.3805C18.7226 7.02773 19 6.76494 19 6.44076V4.67989C19 4.03158 18.4453 3.50599 17.7609 3.50599ZM7.6413 3.31035V3.50599H4.72662C3.95653 3.50599 3.35046 2.82586 3.54279 2.06627C3.62752 1.73176 3.88238 1.44661 4.21203 1.30226C4.66469 1.10405 5.16611 1.16768 5.54629 1.49368L7.64182 3.29305C7.64171 3.29885 7.6413 3.30455 7.6413 3.31035ZM15.4855 2.44491C15.4394 3.05497 14.8577 3.50606 14.2121 3.50606H11.3587V3.31042C11.3587 3.30349 11.3583 3.29664 11.3582 3.28971C11.8329 2.88204 12.8627 1.99779 13.4212 1.51815C13.7387 1.24559 14.1828 1.11835 14.5934 1.23437C15.1826 1.40087 15.5286 1.87555 15.4855 2.44491Z"
                        />
                        <path d="M1.23926 8.20166V16.8104C1.23926 17.4587 1.79401 17.9843 2.47838 17.9843H8.26098V8.20166H1.23926Z" />
                        <path d="M10.7393 8.20166V17.9843H16.5219C17.2062 17.9843 17.761 17.4587 17.761 16.8104V8.20166H10.7393Z" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1701_7763">
                            <rect width="19" height="18" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

            </span>
      {{ trans.get('profile:edit.verify_your_email_for') }}
    </p>
    <button
      class="btn button--tight main-panel__top-bar-button"
      @click.prevent="$eventHub.$emit('EmailVerificationModalOpen')"
    > Abholen
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EmailValidationBar',
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    show() {
      return !!this.user && !this.user.email_verified_at;
    },
  },
  watch: {},
  methods: {},
  mounted() {
  },
};
</script>
